import camelCase from 'lodash/camelCase'
const requireModule = require.context('.', true, /\.js$/)
const modules = {}

requireModule.keys().forEach(fileName => {
  if (fileName.match('index.js')) {
    return
  }

  const nameSplit = fileName.replace(/(\.\/|\.js)/g, '').split('/')


  const [name, sub] = nameSplit
  const moduleName = camelCase(name)
  const actualFragment = requireModule(fileName)

  modules[moduleName] = modules[moduleName] || {
    namespaced : true
  }
  modules[moduleName][sub] = actualFragment.default || actualFragment
})

export default modules
